export const INITIATIVE_ARRAY_FIELDS = ['teams', 'topics', 'countries', 'departments'];

export const VALID_FILTERS_FOR_SET = ['department', 'team', 'timeframe', 'toggles'];
